import { render, staticRenderFns } from "./SchoolSocialPassportReport.vue?vue&type=template&id=7d1d4d14&"
import script from "./SchoolSocialPassportReport.vue?vue&type=script&lang=js&"
export * from "./SchoolSocialPassportReport.vue?vue&type=script&lang=js&"
import style0 from "./SchoolSocialPassportReport.vue?vue&type=style&index=0&id=7d1d4d14&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports